enum LoginTypeConstants {
  CD_CATEGORY = '3',
  CD_HEALTH_INSURANCE = '2',
  CD_ORIGIN = '4',
  CD_PHYSICAL_PERSON = '1',
}

export default LoginTypeConstants;